<section class="hero">
  <div class="hero-left">
    <h1>{{ t('landing.headline') }}</h1>
    <p class="sub">{{ t('landing.sub') }}</p>
    <div class="cta">
      <a class="btn primary" routerLink="/register">{{ t('landing.cta_primary') }}</a>
      <a class="btn ghost" routerLink="/plans">{{ t('landing.cta_plans') }}</a>
    </div>
  </div>
  <div class="hero-right">
    <!-- placeholder illustration / replace with svg -->
    <div class="illustration">🧾📊☕</div>
  </div>
</section>

<section class="plans-preview">
  <h2>{{ t('plans.title') }}</h2>
  <div class="cards">
    <div class="card" *ngFor="let p of plans">
      <h3>{{ p.title }}</h3>
      <div class="price">{{ p.price }}</div>
      <p>{{ p.desc }}</p>
      <a class="btn" routerLink="/plans">{{ t('plans.view') }}</a>
    </div>
  </div>
</section>
